module.exports = "https://cdn.littlereply.com/tt/resource/coins_3.32d19d42f130294f5c5989894a5660e9.png";